/*
 * Copyright © 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import Grid from "@mui/material/Grid";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import { translate, translateHelperTextIfExists } from "@/src/services/translations/translations";
import { requiredValidator } from "@/src/services/validationRules";
import React, { useEffect } from "react";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { getFormDefinitions } from "@/src/services/formDefinitions/formDefinitions";
import { ValidatorType } from "@/src/types/ValidatorType";
import wizardStyle from "@/src/components/Form/wizardStyle";

type TextFieldConfiguredProps = {
  caseData: Record<string, any>;
  fieldPath: string;
  required?: boolean | undefined;
  multiline?: boolean;
};
export default function TextFieldConfigured({ caseData, fieldPath, required, multiline = false }: TextFieldConfiguredProps) {
  const helperText = translateHelperTextIfExists(caseData, fieldPath);
  const question = translate(`${caseData.name}.${fieldPath}.question`, caseData);
  const label = translate(`${caseData.name}.${fieldPath}.label`, caseData);
  const validators: Array<ValidatorType> = [];

  useEffect(() => {
    if (required) {
      validators.push(requiredValidator());
    }
    if (getFormDefinitions(caseData, fieldPath) && getFormDefinitions(caseData, fieldPath).validators) {
      const definedValidators: Array<ValidatorType> = getFormDefinitions(caseData, fieldPath).validators;
      definedValidators.forEach((definedValidator) => {
        validators.push(definedValidator);
      });
    }
  }, []);

  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>{question}</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField name={fieldPath} label={label} multiline={multiline} rows={multiline ? 6 : 1} helperText={helperText} validators={validators} />
      </Grid>
    </>
  );
}
